import React from 'react';
import { CardProps } from '../types';

const Card = ({ children, title, className = '', theme = 'light' }: CardProps & { theme?: 'light' | 'dark' }) => (
    <div className={`${theme === 'dark' ? 'bg-zinc-900/80 border-zinc-800 shadow-black/50' : 'bg-white/80 border-white/50 shadow-zinc-200/50'} backdrop-blur-xl rounded-2xl shadow-xl border overflow-hidden ${className}`}>
        {title && (
            <div className={`px-6 py-5 border-b  ${theme === 'dark' ? 'border-zinc-800 bg-zinc-900/50' : 'border-zinc-100 bg-zinc-50/50'}`}>
                <h3 className={`text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r ${theme === 'dark' ? 'from-white to-zinc-400' : 'from-zinc-900 to-zinc-600'}`}>
                    {title}
                </h3>
            </div>
        )}
        <div className="p-6">{children}</div>
    </div>
);

export default Card;